/**
 * Singleton TanStack Query client shared across the entire application.
 *
 * Provided to the React tree via <QueryClientProvider> in index.js.
 * Queries and mutations throughout the app use this single instance so that
 * cache invalidation (e.g. a mutation invalidating a query key) works globally.
 */
import { QueryClient } from '@tanstack/react-query';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 30_000,
            retry: 1,
        },
    },
});

export default queryClient;
